import { useField } from 'formik';
import { FC } from 'react';

import type { BaseSelectInputProps } from '@types';
import { cn, validateEmptyValue } from '@utils';

import { BaseSelectInput } from '.';

export const FilledSelectInput: FC<BaseSelectInputProps> = ({
  name,
  label,
  className,
  labelClassName,
  disabled,
  ...props
}) => {
  const [field] = useField(name);
  const isValueValid = !validateEmptyValue(field.value);

  return (
    <BaseSelectInput
      name={name}
      disabled={disabled}
      label={
        label && (
          <label
            htmlFor={name}
            className={cn(
              'absolute top-0 left-0 h-full pl-2 disabled:pl-0 text-gray-400 flex items-center',
              'transform transition-all translate-x-2',
              'group-focus-within:translate-x-0 group-focus-within:translate-y-0.5 group-focus-within:h-1/2 group-focus-within:pl-3',
              'peer-valid:translate-x-0 peer-valid:translate-y-0.5 peer-valid:h-1/2 peer-disabled:h-1/2 peer-disabled:translate-y-0.5 peer-valid:pl-3 peer-disabled:pl-1',
              disabled && 'text-gray-400/60',
              isValueValid
                ? 'text-smLabel font-medium'
                : 'text-xs group-focus-within:text-smLabel peer-valid:text-smLabel group-focus-within:font-medium peer-valid:font-medium',
              labelClassName,
            )}
          >
            {label}
          </label>
        )
      }
      className={cn(
        'w-full px-3 peer outline-none border-0',
        isValueValid
          ? 'pt-6 pb-1'
          : 'group-focus-within:pt-10 peer-valid:pt-10 peer-valid:pb-5 group-focus-within:pb-5',
        className,
      )}
      {...props}
    />
  );
};
